import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Linkedin, Instagram, Twitter } from "lucide-react";
import { useNavigate } from "react-router-dom";

const FOOTER_SECTIONS = {
    products: {
        title: "Our Products",
        items: [
            {
                heading: "Our Products",
                links: ["Vetri Dashboard"],
            },
        ],
    },
    services: {
        title: "Services",
        items: [
            {
                heading: "Services",
                links: [
                    "Deployment & Configuration",
                    "Data Cleaning & Migration",
                    "Staff Training & Onboarding",
                    "API Integration & Automation",
                    "Maintenance & Technical Support",
                    "Data Management & Optimization",
                    "Hiring, Payroll & HR Operations",
                ],
            },
        ],
    },
    contact: {
        title: "Contact Us",
        items: [
            {
                heading: "Contact Us",
                links: ["ADDRESS : #6, 2nd Floor, Maruthi Complex, New BEL Road, Bangalore, Karnataka, 560054", "+91 79946 70962", "contact@edulynks.in"],
            },
        ],
    },
};

// ✅ Route Map for Footer Navigation
const routeMap = {
    "Deployment & Configuration": "/deployment-configuration",
    "Data Cleaning & Migration": "/data-cleaning-migration",
    "Staff Training & Onboarding": "/staff-training-onboarding",
    "API Integration & Automation": "/api-integration-automation",
    "Maintenance & Technical Support": "/maintenance-support",
    "Data Management & Optimization": "/data-management",
    "Hiring, Payroll & HR Operations": "/hiring-payrolls",
    "Vetri Dashboard": "/our-product-vetri",
};

const Footer = () => {
    const navigate = useNavigate();

    useEffect(() => {
        AOS.init({ duration: 800, once: false });
    }, []);

    return (
        <section className="w-full px-[5%] bg-white">
            <footer className="max-w-7xl mx-auto bg-gray-900 text-white py-8 px-4 md:px-16 relative overflow-hidden rounded-t-[40px]">
                {/* Background Design */}
                <div className="absolute inset-0 opacity-5">
                    <div
                        className="absolute inset-0"
                        style={{
                            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' ...")`,
                        }}
                    />
                </div>

                <div className="max-w-7xl mx-auto relative z-10">
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 items-start">
                        {/* Social Section */}
                        <div className="flex flex-col gap-2 items-start" data-aos="fade-up" data-aos-delay="400">
                            <h4 className="text-lg font-semibold mb-2">Follow Us</h4>
                            <div className="flex gap-2">
                                <a href="https://linkedin.com" target="_blank" className="w-8 h-8 bg-gray-800 rounded flex items-center justify-center hover:bg-gray-700 transition">
                                    <Linkedin className="w-4 h-4 text-gray-400 hover:text-white" />
                                </a>
                                <a href="https://instagram.com" target="_blank" className="w-8 h-8 bg-gray-800 rounded flex items-center justify-center hover:bg-gray-700 transition">
                                    <Instagram className="w-4 h-4 text-gray-400 hover:text-white" />
                                </a>
                                <a href="https://twitter.com" target="_blank" className="w-8 h-8 bg-gray-800 rounded flex items-center justify-center hover:bg-gray-700 transition">
                                    <Twitter className="w-4 h-4 text-gray-400 hover:text-white" />
                                </a>
                            </div>
                        </div>

                        {/* Footer Links */}
                        {Object.entries(FOOTER_SECTIONS).map(([key, section], idx) => (
                            <div key={idx} data-aos="fade-up" data-aos-delay={`${idx * 100}`}>
                                <h4 className="text-lg font-semibold mb-2">{section.title}</h4>
                                {section.items.map((item, i) => (
                                    <ul key={i} className="space-y-1 text-gray-400 text-sm">
                                        {item.links.map((link, j) => (
                                            <li
                                                key={j}
                                                onClick={() => {
                                                    if (routeMap[link]) {
                                                        navigate(routeMap[link]);
                                                    } else {
                                                        // Contact Interactions
                                                        if (link.includes("+91")) {
                                                            window.location.href = `tel:${link.replace(/\s+/g, "")}`;
                                                        } else if (link.includes("@")) {
                                                            window.location.href = `mailto:${link}`;
                                                        } else if (link.includes("ADDRESS") || link.includes("Road") || link.includes("Bangalore")) {
                                                            window.open(`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(link)}`, "_blank");
                                                        }
                                                    }
                                                }}
                                                className={`mb-2 transition-colors duration-300 ${!routeMap[link] ? "cursor-pointer hover:text-white" : "cursor-pointer hover:text-white"}`}
                                            >
                                                {link}
                                            </li>
                                        ))}
                                    </ul>
                                ))}
                            </div>
                        ))}
                    </div>

                    {/* Bottom Section */}
                    <div className="mt-6 border-t border-gray-800 pt-4 text-center md:text-left text-sm text-gray-500 flex flex-col md:flex-row justify-between gap-2">
                        <p>© 2025 EduLynks — All Rights Reserved.</p>
                        <div className="flex gap-4">
                            <span onClick={() => navigate("/privacy")} className="cursor-pointer hover:text-gray-300">
                                Privacy Policy
                            </span>
                            <span onClick={() => navigate("/terms")} className="cursor-pointer hover:text-gray-300">
                                Terms of Service
                            </span>
                        </div>
                    </div>
                </div>
            </footer>
        </section>
    );
};

export default Footer;
